// extracted by mini-css-extract-plugin
export default {"containerPage":"ListPage_containerPage__t9TzG","container":"ListPage_container__jFiia","title":"ListPage_title__xq35Q","titleWithoutActions":"ListPage_titleWithoutActions__9IDuk"};